import { text0, text4, text5 } from '@osmosis/tailwind-ui/styles/text';
import { bg1, bg2, bgBtnRed } from '@osmosis/tailwind-ui/styles/background';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Button } from '@osmosis/tailwind-ui/components/Button';
import { H4 } from '@osmosis/tailwind-ui/components/Text';

import React from 'react';

import { FormattedMessage } from 'react-intl';

type Props = {
  handleClose: () => void;
  handleDelete: () => Promise<void>;
};

/**
 * DeletePlaylistModalBox.
 */
const DeletePlaylistModalBox = (props: Props) => {
  const { handleClose, handleDelete } = props;

  return (
    <Box className={`min-w-[unset] md:min-w-[400px] lg:min-w-[500px] p-4`}>
      <H4 className={`opacity-75 ${text5} text-center`}>
        <FormattedMessage
          defaultMessage="You are about to delete this playlist, this cannot be undone!"
          id="playlist.delete-playlist-modal-box.title"
        />
      </H4>
      <Box className={`h-px w-full ${bg1} flex-1 mt-4`} />
      <Flex className={`justify-center mt-4`}>
        <Button
          onClick={handleClose}
          data-testid="deletePlaylistModalBox-cancelBtn"
          className={`mr-2 ${bg1} hover:${bg2} ${text4} min-w-20 rounded-[20px]`}
        >
          <FormattedMessage defaultMessage="Cancel" id="common.cancel" />
        </Button>
        <Button
          onClick={handleDelete}
          data-testid="deletePlaylistModalBox-deleteBtn"
          className={`ml-2 ${bgBtnRed} ${text0} min-w-20 rounded-[20px]`}
        >
          <FormattedMessage
            defaultMessage="Delete"
            id="playlist.delete-playlist-modal-box.delete"
          />
        </Button>
      </Flex>
    </Box>
  );
};

export default DeletePlaylistModalBox;
